import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MStaticClient, MStaticInter } from '@argalis-apps/models';
import { AccountConfigService } from '../../../../services/account-config/account-config.service';

@Component({
  selector: 'argalis-apps-static-marge-card',
  templateUrl: './marge-card.component.html',
  styleUrls: ['../ca-card/ca-card.component.scss']
})
export class MargeCardComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  @Input('margeData')
  set _margeData(value: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo) {
    this.margeData = value;
  }
  @Input('indicator')
  set _indicator(value: boolean) {
    this.indicator = value;
  }
  public margeData: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo;
  public indicator: boolean;
  public headerBackground = 'uk-background-muted';
  public headerColor = 'no-style-applied';
  public bodyBackground = 'no-style-applied';
  public bodyColor = 'no-style-applied';

  constructor(private accountConfigService: AccountConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }
}
